import React from 'react';
import urlUtil, { isOutCustomerService } from '@/utils/url';
import './index.scss';

export const PermissionDenied: React.FC = () => <div className="permission-denied">暂无权限</div>;

export function permissionRequired<P>(Component: React.ComponentType<P>): React.ComponentType<P> {
    return function PermisstionRequired(props: P) {
        if (urlUtil.commonParams.providerRole !== 0 && !isOutCustomerService) {
            return <PermissionDenied />;
        }
        return <Component {...props} />;
    };
}
